import { render, staticRenderFns } from "./ItemPackingLogs.vue?vue&type=template&id=327929c8"
import script from "./ItemPackingLogs.vue?vue&type=script&lang=js"
export * from "./ItemPackingLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports